import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n/useTranslation';
import startAnalysisImage from '../assets/img/c5madvf.jpeg';
import './StartAnalysisPage.css';

const StartAnalysisPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBackClick = () => {
    navigate('/');
  };

  const handleStartAnalysisClick = () => {
    console.log('Navigating to questionnaire...');
    navigate('/questionnaire');
  };

  return (
    <div className="start-analysis-page">
      <nav className="top-nav">
        <button className="back-button" onClick={handleBackClick}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <span className="nav-text">{t('startAnalysis.navTitle')}</span>
      </nav>
      
      <div className="content-container">
        <div className="image-section">
          <img src={startAnalysisImage} alt={t('startAnalysis.imageAlt')} className="analysis-image" />
        </div>
        
        <div className="text-section">
          <h1 className="main-heading">{t('startAnalysis.heading')}</h1>
          <p className="description">
            {t('startAnalysis.description')}
          </p>
          <button 
            type="button"
            className="start-button" 
            onClick={handleStartAnalysisClick}
          >
            {t('startAnalysis.cta')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartAnalysisPage;
